export default "__VITE_ASSET__fEF$AEEN__"